import React from 'react';
import { useSelector } from 'react-redux';
import { useState, useEffect } from "react";
import useSnackbar from '../../../hooks/useSnackbar';
import { getTransactionCustom } from '../../../api/transaction-type';
import { slugMap } from '../../../config/slug-config';
import { useParams } from 'react-router-dom';
import { Box, Grid, CircularProgress, Button, Stack, FormControl, InputLabel, Select, MenuItem, Tab, Tabs, } from '@mui/material';
import { GridComp6 } from "../../../components/GridComponents";
import { CustomCheckBoxComp126 } from "../../../components/CheckboxComp";
import { BgDeprecitionHistoryTable, BgFAMAssetTable, BgIncomeTable, BgSummaryrecordTable } from '../../../config/grid-column-defs';
import AgGridPaginatedTable from '../../../components/AgGridPaginatedTable';
import { makeStyles } from "@mui/styles";
import TabPanel from "../../../components/TabPanel";

const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));

export default function RevenueArrangementCustom({ tabIndexP }) {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const { data: user } = useSelector(state => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);

  const pageDetail = slugMap[params.slug];
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  const [rowData, setRowData] = useState([]);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {  
  //     setTableRefreshCount(prev => prev + 1);
  // }

  useEffect(() => {
    if (user.token ) {
      getTransactionCustomData();
    }
  }, []);

  async function getTransactionCustomData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCustom(user.token, { id: params.docNo });
      setRowData(data.data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      setLoading(false);
      return { error: true }
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading ? (
        <>
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "15px",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </>
      ) : (
        <Box className="viewDetilsBox">
          {/* {rowData.map((d, i) => ( */}
            <Grid container>
              <CustomCheckBoxComp126 title={"SHIPPING CODE"} data={rowData.exclude_from_deferred}/>
              <GridComp6 title={"TAX CREDIT"} data={rowData.business_unit} />         
              <CustomCheckBoxComp126 title={"TAX INCLUDED"} data={rowData.helix}/>          
            </Grid>
          {/* ))} */}
          <Tabs
          value={tabIndexRelatedRecord}
          onChange={(e, nv) => setTabIndexRelatedRecord(nv)}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={`${classes.spacedTabs} tabs-sub-bkg`}
        >
          <Tab label="BG Summary Records" />
          <Tab label="FAM Expense/Income" />
          <Tab label="FAM Depreciation History" />
          <Tab label="FAM Asset" />
        </Tabs>

        <TabPanel value={tabIndexRelatedRecord} index={0}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>VIEW</InputLabel>
                <Select value="" label="VIEW">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>BG Summary Records</InputLabel>
                <Select value="" label="BG Summary Records">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ p: 1 }}>
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New BG Summary Records</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>

          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgSummaryrecordTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>

        <TabPanel value={tabIndexRelatedRecord} index={1}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>VIEW</InputLabel>
                <Select value="" label="VIEW">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>FAM Expense/Income</InputLabel>
                <Select value="" label="FAM Expense/Income">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ p: 1 }}>
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Expense/Income</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>

          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgIncomeTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>

        <TabPanel value={tabIndexRelatedRecord} index={2}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>VIEW</InputLabel>
                <Select value="" label="VIEW">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>FAM Depreciation History</InputLabel>
                <Select value="" label="FAM Depreciation History">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ p: 1 }}>
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Depreciation History</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>

          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgDeprecitionHistoryTable}
            refreshCounter={0}
          />
        </TabPanel>

        <TabPanel value={tabIndexRelatedRecord} index={3}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>VIEW</InputLabel>
                <Select value="" label="VIEW">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>FAM Asset</InputLabel>
                <Select value="" label="FAM Asset">
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ p: 1 }}>
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Asset</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>

          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgFAMAssetTable}
            refreshCounter={0}
          />
        </TabPanel>
        </Box>
      )}
    </>
  )
}



